import { render } from "./POS.vue?vue&type=template&id=cfd89564&scoped=true"
import script from "./POS.vue?vue&type=script&lang=js"
export * from "./POS.vue?vue&type=script&lang=js"

import "./POS.vue?vue&type=style&index=0&id=cfd89564&scoped=true&lang=css"
import "./POS.vue?vue&type=style&index=1&id=cfd89564&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/MOTOPIRUETAS/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd89564"]])

export default __exports__